import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import MainContent from "../../layouts/maincontent/MainContent";
import styles from "../support/support.module.css";
import support from "../../assets/img/Active Support-bro.png";
import tel from "../../assets/img/vuesax-bold-call-calling.png";
import mail from "../../assets/img/vuesax-linear-sms.png";
import Lottie from "react-lottie";
import animationData from "../../lotties/supportAnimation .json";
import { useNavigate  } from "react-router-dom";

function Support() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    const storedFirstName = localStorage.getItem("user-full-name");
    if (storedFirstName) {
      setFirstName(storedFirstName);
    }
  }, []);
  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className={`${styles["support-section"]} pt-lg-5 pb-lg-3`}>
          <div className="container mt-lg-4 ">
            <div className={styles.headerRow}>
              <button
                className={`${styles["btn-arrow"]} ms-3`}
                onClick={() => navigate(`/`)} 
              >
                <i className="fa-solid fa-arrow-right mt-1"></i>
              </button>

              <h4 className={styles.title}>
                الدعم الفني
              </h4>
            </div>
            <div className="row">
              {/* Support contact column (image) */}
              <div className="col-lg-6 order-lg-2">
                <Lottie options={defaultOptions} />

                {/* <img src={support} alt="Active-Support" className="img-fluid" /> */}
              </div>

              {/* Support header column */}
              <div
                className={`${styles["header-col"]} col-lg-6 order-lg-1 pt-lg-5`}
              >
                {/* start Support paragraph  */}

                <p className={`${styles["support-paragraph"]} mt-lg-5`}>
                  للاستفسارات، يمكنكم التواصل معنا عبر
                </p>

                {/* end Support paragraph  */}

                {/* start tel div  */}

                <div className="d-flex pt-lg-5 ">
                  <div className={`${styles["img-call"]} `}>
                    <img
                      src={tel}
                      className="img-lg-fluid mt-2 ms-lg-2"
                      alt="tel"
                    />
                  </div>

                  <a
                    className={`${styles["support-contact"]} d-lg-flex mb-1 me-lg-2 text-center`}
                    href="tel:0235356868"
                  >
                    <p> رقم الهاتف </p>

                    <strong className="me-lg-5">0235356868</strong>
                  </a>
                </div>

                {/* end tel div  */}

                {/* start mail div  */}

                <div className="d-flex pt-lg-5">
                  <div className={`${styles["img-mail"]} `}>
                    <img
                      src={mail}
                      className="img-lg-fluid mt-2 ms-lg-2"
                      alt="mail"
                    />
                  </div>

                  <a
                    className={`${styles["support-contact"]} d-lg-flex me-lg-2`}
                    href="mailto:Epay@rta.gov.eg"
                  >
                    <p>البريد الإلكتروني</p>

                    <strong className="me-lg-5">Epay@rta.gov.eg</strong>
                  </a>
                </div>

                {/* end mail div  */}
              </div>
            </div>

            <div class="row justify-content-center align-items-center">
  <div className="col-12 d-flex justify-content-center align-items-center">
    <p className="fs-3 text-center p-4 mb-5 pt-0">
      مواعيد العمل الرسمية طوال ايام الاسبوع من الساعة التاسعة صباحا
      حتى الساعة الخامسة مساء
    </p>
  </div>
</div>


          </div>
        </section>
      )}
    </MainContent>
  );
}
export default Support;
